(function () {
    const desktopMedia = window.matchMedia("(min-width: 1024px)");

    const syncButtonGroupWidths = () => {
        const groups = Array.from(document.querySelectorAll('[class*="__buttons"]')).filter(group => {
            const isBlockGroup = Array.from(group.classList).some(className => className.startsWith("block-"));
            const buttons = Array.from(group.children).filter(child => child.classList.contains("component-button"));

            return isBlockGroup && buttons.length > 1;
        });

        groups.forEach(group => {
            group.style.removeProperty("--wrapping-button-width");

            if (!desktopMedia.matches) {
                return;
            }

            const buttons = Array.from(group.children).filter(child => child.classList.contains("component-button"));
            const visibleButtons = buttons.filter(button => button.getClientRects().length);
            const buttonRows = visibleButtons.reduce((rows, button) => {
                const top = Math.round(button.getBoundingClientRect().top);
                const hasMatchingRow = rows.some(rowTop => Math.abs(rowTop - top) <= 1);

                if (!hasMatchingRow) {
                    rows.push(top);
                }

                return rows;
            }, []);

            if (buttonRows.length < 2) {
                return;
            }

            const largestWidth = visibleButtons.reduce((largest, button) => {
                const width = Math.ceil(button.getBoundingClientRect().width);
                return Math.max(largest, width);
            }, 220);

            group.style.setProperty("--wrapping-button-width", `${largestWidth}px`);
        });
    };

    const scheduleButtonGroupWidthSync = () => {
        window.requestAnimationFrame(syncButtonGroupWidths);
    };

    syncButtonGroupWidths();
    window.addEventListener("resize", scheduleButtonGroupWidthSync, { passive: true });

    if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(syncButtonGroupWidths);
    }

    const shareButtons = document.querySelectorAll("[data-share]");

    if (shareButtons.length) {
        shareButtons.forEach(button => {
            button.addEventListener("click", (e) => {
                e.preventDefault();

                const platform = button.getAttribute("data-share");
                const url = encodeURIComponent(window.location.href);
                const title = encodeURIComponent(document.title);
                let shareUrl = "";

                switch (platform) {
                    case "facebook":
                        shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${url}`;
                        break;
                    case "twitter": // Still using Twitter endpoint even though branded X
                        shareUrl = `https://twitter.com/intent/tweet?url=${url}&text=${title}`;
                        break;
                    case "linkedin":
                        shareUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${url}&title=${title}`;
                        break;
                    default:
                        return;
                }

                window.open(shareUrl, "_blank", "noopener,noreferrer,width=600,height=400");
            });
        });
    }
})();
